export const KEY_PREFIX = "useStorage__";
export const KEY_USE_STORAGE_KEYS = "useStorage_KEYS";
const sortObjectFieldsRecursively = (obj) => {
    if (typeof obj === "object" && !Array.isArray(obj) && obj !== null) {
        const newObj = {};
        for (const key of Object.keys(obj).sort()) {
            newObj[key] = sortObjectFieldsRecursively(obj[key]);
        }
        return newObj;
    }
    return obj;
};
export const valueToStoredString = (value) => {
    if (typeof value === "string" ||
        typeof value === "number" ||
        typeof value === "boolean" ||
        typeof value === "object" ||
        value === null) {
        return encodeURI(JSON.stringify(sortObjectFieldsRecursively(value)));
    }
    else {
        return undefined;
    }
};
export const storedStringToValue = (storedString) => {
    try {
        return JSON.parse(decodeURI(storedString));
    }
    catch (error) {
        console.log(error);
        console.log("storedString: ", storedString);
        return undefined;
    }
};
export const stringifyKey = (key) => {
    return (KEY_PREFIX + encodeURI(JSON.stringify(sortObjectFieldsRecursively(key))));
};
export const parseKeyString = (key) => {
    return JSON.parse(decodeURI(key.substring(KEY_PREFIX.length)));
};
